import React from 'react';
import ReactPlayer from 'react-player';

const TVPlayer = ({ url }) => {
  return (
    <div className="container w-full aspect-w-16 aspect-h-9 bg-gray-900 rounded-lg shadow-lg overflow-hidden">
      <ReactPlayer
        url={url}
        playing={true}
        controls={true}
        width="100%"
        height="100%"
        // className="absolute top-0 left-0"
      />
    </div>
  );
};

export default TVPlayer;
